
import React from "react";
import { Helmet } from "react-helmet-async";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

const Refund = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>Refund Policy | Upfixe</title>
        <meta name="description" content="Learn about Upfixe's refund policy for monthly subscriptions and free plans." />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://upfixe.com/refund-policy" />
      </Helmet>
      <Header />
      <div className="container mx-auto px-4 pt-32 pb-12 flex-grow">
        <h1 className="text-3xl font-bold mb-8">Refund Policy</h1>
        
        <div className="prose max-w-none">
          <p className="text-sm text-muted-foreground mb-4">
            UPFIXE, UNIPESSOAL LDA ("Upfixe Ads")
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">Free Plan</h2>
          <p>
            We offer a free plan forever with no credit card required. This allows you to explore our service and decide if you want to upgrade to unlock additional features. The free plan includes 1 brand import, 1 campaign generation per month, and 1 report per month.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">Monthly Subscriptions</h2>
          <ul className="list-disc pl-6 mt-2 mb-4">
            <li>Monthly subscriptions can be canceled at any time.</li>
            <li>Once a payment is made, we do not offer refunds for the current billing cycle.</li>
            <li>You will retain access to the service until the end of your paid month.</li>
            <li>You can always downgrade to our free plan after cancellation.</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">Yearly Subscriptions</h2>
          <ul className="list-disc pl-6 mt-2 mb-4">
            <li>Yearly subscriptions are billed upfront and offer a discount compared to monthly plans.</li>
            <li>If you cancel a yearly subscription, we may issue a pro-rated refund for the unused portion of your subscription. Refunds are calculated based on the number of full months remaining in your plan.</li>
            <li>No refunds will be issued if you've already used more than 50% of your yearly subscription period.</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">Refund Eligibility</h2>
          <p>
            We may issue refunds under the following circumstances:
          </p>
          <ol className="list-decimal pl-6 mt-2 mb-4">
            <li><strong>Technical Issues</strong>: If technical problems prevent you from accessing the service and we are unable to resolve them within 7 days.</li>
            <li><strong>Billing Errors</strong>: If you were charged incorrectly or experienced duplicate charges.</li>
          </ol>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">How to Request a Refund</h2>
          <p>
            To request a refund, please contact our support team at <a href="mailto:support@upfixe.com" className="text-primary hover:underline">support@upfixe.com</a> with your order details and reason for requesting a refund. Refund requests must be submitted within 30 days of payment.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">Non-Refundable Items</h2>
          <ul className="list-disc pl-6 mt-2 mb-4">
            <li>Refunds are not available for services that have been actively used during the billing period.</li>
            <li>Discounts or promotional offers applied to yearly plans are non-refundable.</li>
          </ul>
          
          <p className="mt-8 text-sm text-muted-foreground">
            Last Updated: {new Date().toLocaleDateString()}
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Refund;
